var render = function render(){var _vm=this,_c=_vm._self._c;return _c('XScroll',[_c('div',{staticClass:"width"},[_vm._v("1")]),_c('div',{staticClass:"width"},[_vm._v("2")]),_c('div',{staticClass:"width"},[_vm._v("3")]),_c('div',{staticClass:"width"},[_vm._v("4")])])
}
var staticRenderFns = []

export { render, staticRenderFns }